/* @flow */

import type { CombinedReducers } from '../../../reducers';
import type { Dispatch } from '../../../types/types';
import type { NetgemApiEmitterType, RequestResponseMethodDefinitionType } from '../emitter';

import { BO_PURCHASE_STATUS_OK } from '../../../../libs/netgemLibrary/videofutur/types/ErrorCodes';
import { REDUX_MSG_REQUEST_BO_PURCHASE } from '../../constants';
import getRequestDetails from './helpers/requestCommon';
import { BO_API_PURCHASE, type BO_RESPONSE_WITH_ETAG } from './types/common';
import { type BO_API_PURCHASE_RESPONSE_TYPE } from './types/purchase';

const mapResponse: (response: any) => BO_API_PURCHASE_RESPONSE_TYPE = (response) => {
  const {
    body: {
      data: { price },
    },
  } = response;

  return {
    price,
    status: BO_PURCHASE_STATUS_OK,
  };
};

const sendPurchaseRequest: (distributorId: string, vtiId: number, promocode: string, signal?: AbortSignal) => RequestResponseMethodDefinitionType =
  (distributorId, vtiId, promocode, signal) =>
  (dispatch: Dispatch, getState: () => CombinedReducers, NetgemApiEmitter: NetgemApiEmitterType): Promise<BO_API_PURCHASE_RESPONSE_TYPE> => {
    // Object 'requestDetails' contains 'headers', 'method' and 'uri' parameters
    const requestDetails = getRequestDetails(getState, distributorId, BO_API_PURCHASE);

    return NetgemApiEmitter.emit(REDUX_MSG_REQUEST_BO_PURCHASE, {
      ...requestDetails,
      promocode,
      signal,
      vtiId,
    }).then(({ response }: BO_RESPONSE_WITH_ETAG) => mapResponse(response));
  };

export default sendPurchaseRequest;
